import styled from 'styled-components';
import { inline, inset, stacked } from 'app/shared/styles/_spacing';
import { font } from 'app/shared/styles/_fontsize';
import { colors } from 'app/shared/styles/_colors';
import { viewports } from 'app/shared/styles/_breakpoints';

// Components
import ReactSlider from 'react-slider';

export const InfoCardLi = styled.li`
  ${inset._1x};
  margin-bottom: 8px;

  @media ${viewports['xl-and-up']} {
    display: flex;
    padding-right: 16px;
    justify-content: space-between;
    width: 100%;
  }
`;

export const FlexHeader = styled.header`
  display: flex;
  ${stacked._2x};
  align-items: center;

  @media ${viewports['xl-and-up']} {
    max-width: 404px;
    width: 50%;
  }
`;

export const InfoCardImg = styled.img`
  ${inline._2x};
`;

export const InfoCardTitle = styled.b`
  ${font.md};
  color: ${colors['$hpx-blue-600']};
`;

export const InfoCardDescription = styled.p`
  font-size: 16px;
  color: ${colors['$hpx-grey-600']};
`;

export const InfoCardFilterContainer = styled.section`
  ${inset._2x};
  width: 100%;
  border: 1px solid ${colors['$hpx-grey-500']};
  border-radius: 4px;
  box-shadow: 0 2px 4px 0 rgb(0 0 0 / 5%);
  font-size: 12px;
  min-height: 109px;

  @media ${viewports['xl-and-up']} {
    max-width: 404px;
    width: 50%;
    margin-left: 16px;
  }
`;

// Info card price slider
export const InfoCardPriceSlider = styled(ReactSlider)`
  width: 100%;
`;

export const SliderThumb = styled.div`
  bottom: -16px;
  cursor: grab;
  line-height: 30px;
  width: 30px;
  border: 1px solid ${colors['$hpx-grey-500']};
  border-radius: 4px;
  box-shadow: 2px 2px 2px 0 rgb(0 0 0 / 15%);
  background: ${colors['$hpx-white']};
  color: ${colors['$hpx-grey-500']};
  font-size: 24px;
  letter-spacing: -1px;
  text-align: center;
  z-index: 3;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
`;

interface SliderTrackProps {
  index: number;
}

export const SliderTrack = styled.div`
  bottom: -6px;
  height: 6px;
  background: ${(props: SliderTrackProps) =>
    props.index === 1 ? `${colors['$hpx-teal-500']}` : `${colors['$hpx-grey-500']}`};
  border-radius: 999px;
`;

export const DisplayText = styled.p`
  ${font.tiny};
  ${stacked._2x};
  text-align: center;
`;

export const SkeletonContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 187px;
  width: 100%;
  gap: 16px;

  // If viewport allows for double column of listings
  @media ${viewports['xl-and-up']} {
    flex-direction: row;
    height: 109px;
  }
`;

export const SkeletonCard = styled.div`
  background: ${colors['$hpx-grey-100']};
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  border-radius: 3px;
  width: 100%;
  height: 100%;

  // If viewport allows for double column of listings
  @media ${viewports['xl-and-up']} {
    width: 50%;
  }
`;
